import './TopBar.css'

export default function Footer() {

  return (
    <div className="footer">
          <p>made with love in Incline Village</p>
    </div>
  )
}